<!-- eslint-disable vue/no-mutating-props -->
<script lang="ts">
export default {
    name: 'SelectFilter',
    props: {
        translationName: { type: String, required: true },
        filter: { type: Object, required: true },
    },
    emits: ['updateFilters', 'clearFilter', 'updateFilterState'],
    computed: {
        isSelect(): boolean {
            return ['Select', 'Radio'].includes(this.filter?.field_type)
        },
        isCheckBox(): boolean {
            return this.filter?.field_type === 'CheckBox'
        },
        isFile(): boolean {
            return this.filter?.field_type === 'File'
        },
    },
    mounted() {
        this.initSelectedAtStartText()
        this.initUrlQuery()
    },
    methods: {
        initSelectedAtStartText() {
            if (this.filter.initial_value) {
                // Si un filtre avec une valeur par défaut est aussi dans l'url, ne pas initialiser la valeur par defaut, et laisser initUrlQuery passer l'initialisation (init) à true
                const urlKeys = Object.keys(this.$route.query) // ['type_hydrant']
                const isFilterInUrl = urlKeys.find(key => key === this.filter.name)
                if (!isFilterInUrl) {
                    // ---------

                    this.$emit('updateFilterState', { ...this.filter, init: false })
                    const defaultValue = Array.isArray(this.filter.initial_value) ? this.filter.initial_value.map(item => `${item}`) : this.filter.initial_value
                    this.$emit('updateFilterState', { ...this.filter, init: true, value: defaultValue })
                }
            }
        },
        initUrlQuery() {
            if (!this.$route.path.includes('formulaire')) {
                const defaultKeys = Object.keys(this.$route.query) // ['type_hydrant']
                defaultKeys.forEach((key) => {
                    if (this.filter.name === key) {
                        this.$emit('updateFilterState', { ...this.filter, init: false })
                        const values = this.$route.query[key]

                        if (!this.filter.value) { // INIT VALUES TO ARRAY
                            this.$emit('updateFilters', [])
                        }
                        let currentValue = this.filter.value || []
                        // console.log('values', values, this.filter.value)
                        currentValue = Array.isArray(values) ? [...currentValue, ...values] : [...currentValue, values]
                        this.$emit('updateFilterState', { ...this.filter, init: true, value: currentValue })
                    }
                })
            }
        },
        getOptionColor(title: string): string | null {
            return this.filter?.is_tag ? this.filter?.options?.find(option => option.title === title)?.color : null
        },
    },
}
</script>

<template>
    <v-select
        v-model="filter.value"
        :items="filter.available_values"
        :label="filter.translation || $translate(`${translationName}.${filter.name}`)"
        :multiple="filter.multiple"
        :clearable="!filter.multiple"
        variant="solo"
        no-data-text="Aucun choix disponible"
    >
        <!-- TEMPLATE IN DROPDOWN -->
        <template #item="{ props, item }">
            <v-list-item v-bind="props">
                <v-list-item-title class="select-options">
                    <v-chip
                        v-if="filter.multiple || filter?.is_tag"
                        size="x-small"
                        label
                        :variant="$config.public.chips_variant || 'tonal'"
                        :color="getOptionColor(item.title) || $getColor(`${translationName}.${filter.name}.${item.value}`)"
                    >
                        {{ (isSelect || isFile) ? item.value : (isCheckBox ? $translate(`${translationName}.${item.value}`) : $translate(`${translationName}.${filter.name}.${item.value}`)) }}
                    </v-chip>
                    <template v-else>
                        {{ isSelect ? item.value : ((isCheckBox || isFile) ? $translate(`${translationName}.${item.value}`) : $translate(`${translationName}.${filter.name}.${item.value}`)) }}
                    </template>
                </v-list-item-title>
            </v-list-item>
        </template>
        <!-- TEMPLATE IN SELECT INPUT -->
        <template #selection="{ item, index }">
            <span v-if="index < 2">
                <v-chip
                    v-if="filter.multiple || filter?.is_tag"
                    size="small"
                    closable
                    label
                    :variant="$config.public.chips_variant || 'tonal'"
                    :color="getOptionColor(item.value) || $getColor(`${translationName}.${filter.name}.${item.value}`)"
                    @click:close="$emit('clearFilter', item)"
                >
                    {{ (isSelect || isFile) ? item.value : (isCheckBox ? $translate(`${translationName}.${item.value}`) : $translate(`${translationName}.${filter.name}.${item.value}`)) }}
                </v-chip>
                <template v-else>
                    {{ isSelect ? item.value : ((isCheckBox) ? $translate(`${translationName}.${item.value}`) : $translate(`${translationName}.${filter.name}.${item.value}`)) }}
                </template>
            </span>
            <span
                v-if="index === 2"
                class="text-grey text-caption align-self-center"
            >
                (+{{ filter.value.length - 2 }} autre{{ filter.value.length > 3 ? 's' : '' }})
            </span>
        </template>
    </v-select>
</template>
